module.exports = __webpack_public_path__ + "img/introduce.b61c84a1.png";